import { render, staticRenderFns } from "./NotificationTemplate.vue?vue&type=template&id=005c5842&scoped=true&lang=pug"
import script from "./NotificationTemplate.vue?vue&type=script&lang=ts"
export * from "./NotificationTemplate.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTemplate.vue?vue&type=style&index=0&id=005c5842&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c5842",
  null
  
)

export default component.exports